export const HoldsTabRoute = {
  path: '/load/holds',
  load: () => import('./HoldsTab'),
  protected: true,
};
